import React from 'react';
import { useResume } from '../context/ResumeContext';
import { ucfirst } from '../helper';
const AdditionalSectionsName = (props) => {
  const {
    resume,
    handlers: {
      updateResumePreview
    }
  } = useResume();

  return (<>
    {!props.editEnabled && <>
        <h2 className="custom-title" data-rb-field="heading">
          {resume[props.type].name ?? ucfirst(props.type)}
          <i className="icon-pencil" data-rb-field="edit"></i>
        </h2>
      </>
    }
    {props.editEnabled && 
      <input
          type="text"
          className="form-input validate section-name"
          data-rb-field="input"
          name="name"
          defaultValue={resume[props.type]?.name ?? ucfirst(props.type)}
          onChange={(e) => {
            updateResumePreview({ [props.type]: {...resume[props.type], name: e.target.value }});
          }}
          onFocus={(e) => updateResumePreview({ [props.type]: {...resume[props.type], name: e.target.value }})}
          onBlur={(e) => {
              updateResumePreview({ [props.type]: {...resume[props.type], name: e.target.value } })
              props.editDisabled()
          }}
      /> 
    }           
  </>);
}
export default AdditionalSectionsName;

